import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import InputField from "../../../components/InputField";
import api from "../../../api/api";
import Breadcrumbs from "../../../components/Breadcrumbs";
 
const ViewFollowupDetails = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const [enquiry, setEnquiry] = useState(null);
  const [followUpDate, setFollowUpDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
 
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        let response;
        // Use the existing /enquiry-details endpoint which returns customer and followUps
        response = await api.get(`/sales/enquiry-details?customer_id=${id}`);
        const customer = response.data.customer;
        const followUp = response.data.followUps[0] || {};
        setEnquiry({ ...customer, ...followUp });
        // Set follow up date from follow_up table's created_at
        if (followUp.created_at) {
          setFollowUpDate(new Date(followUp.created_at).toLocaleDateString('en-GB'));
        }
      } catch (err) {
        console.error("Error fetching enquiry:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiry();
  }, [id, type]);
 
  if (loading) return <p>Loading enquiry...</p>;
  if (error) return <p>Failed to load enquiry.</p>;
  if (!enquiry) return <p>No customer details found.</p>;
 
  return (
    <>
      <Breadcrumbs />
      <form>
        <div className="row g-3">
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Customer Name"
              value={`${enquiry.first_name || ""} ${enquiry.last_name || ""}`}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Company Name"
              value={enquiry.company_name || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Follow Up Date"
              value={followUpDate}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Customer Type"
              value={enquiry.customer_type || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Industry Type"
              value={enquiry.customer_industry || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Pick Up Location"
              value={enquiry.order_sector_from || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Delivery Location"
              value={enquiry.order_sector_to || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Shipment Segment"
              value={enquiry.shipment_segment || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Trade Segment"
              value={enquiry.trade_segment || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Estimated Monthly Volume"
              value={enquiry.estimated_monthly_volume || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Target Rate Seeked"
              value={enquiry.target_rate_seeked || ""}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Booking Confirmed"
              value={enquiry.booking_confirmed || "Follow Up Pending"}
              disabled
            />
          </div>
 
          {/* Show these fields only when booking is confirmed */}
          {enquiry.booking_confirmed === "Yes" && (
            <>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Order Segment From"
                  value={enquiry.order_segment_from || ""}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Order Segment To"
                  value={enquiry.order_segment_to || ""}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Number Of Packages"
                  value={enquiry.number_of_packages ?? ""}
                  disabled
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Total Value"
                  value={enquiry.total_value || ""}
                  disabled
                />
              </div>
 
              <div className="col-sm-6 col-md-4">
                <InputField label="Length" value={enquiry.length ?? ""} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField label="Breadth" value={enquiry.breadth ?? ""} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField label="Height" value={enquiry.height ?? ""} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField
                  label="Number Of TEUs"
                  value={enquiry.number_of_TEUs ?? ""}
                  disabled
                />
              </div>
            </>
          )}
        </div>
      </form>
    </>
  );
};
export default ViewFollowupDetails;